import { render, staticRenderFns } from "./ProjectSelection.vue?vue&type=template&id=6c4c1255&lang=pug&"
import script from "./ProjectSelection.vue?vue&type=script&lang=js&"
export * from "./ProjectSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports